import type { WebTestId } from '@frontend/test-utils';
import { concatClasses } from '@frontend/web-utils';
import type { Router } from '@frontend/web/router';
import { Link as TLink } from '@tanstack/react-router';
import type { LinkComponentProps } from '@tanstack/react-router/dist/esm/link';

export const NavLinkWrapper = <
  TFrom extends string = string,
  TTo extends string = '',
  TMaskFrom extends string = TFrom,
  TMaskTo extends string = '',
>({
  className,
  testId,
  ...props
}: LinkComponentProps<'a', Router, TFrom, TTo, TMaskFrom, TMaskTo> & { testId?: WebTestId }) => {
  return <TLink className={concatClasses('hover-opacity-effect', className)} data-testid={testId} {...props} />;
};
